var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 18,
    height: 18,
    transform: "translate(1133 122)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7214",
    "data-name": "Group 7214",
    transform: "translate(-1209 -9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3213",
    "data-name": "Rectangle 3213",
    width: 30,
    height: 30,
    rx: 4,
    transform: "translate(1209 9)",
    fill: "#fff2f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_20",
    "data-name": "Mask Group 20",
    transform: "translate(82 -107)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4605",
    "data-name": "Group 4605",
    transform: "translate(1134.412 123.397)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4602",
    "data-name": "Group 4602"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3770",
    "data-name": "Path 3770",
    d: "M586.655,228H571.5v1.443h1.6v8.9a2.168,2.168,0,0,0,2.165,2.165h7.618a2.167,2.167,0,0,0,2.165-2.165v-8.9h1.6Zm-3.047,10.344a.723.723,0,0,1-.722.722h-7.618a.722.722,0,0,1-.722-.722v-8.9h9.061Z",
    transform: "translate(-571.5 -225.514)",
    fill: "#d82424"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1199",
    "data-name": "Rectangle 1199",
    width: 6.495,
    height: 1.443,
    transform: "translate(4.33)",
    fill: "#d82424"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1200",
    "data-name": "Rectangle 1200",
    width: 1.443,
    height: 4.571,
    transform: "translate(5.292 6.335)",
    fill: "#d82424"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1201",
    "data-name": "Rectangle 1201",
    width: 1.443,
    height: 4.571,
    transform: "translate(8.419 6.335)",
    fill: "#d82424"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.4ef0c89b0c4c99340f3162f2429320f1.svg";
export { ForwardRef as ReactComponent };